<template>
    <div>
        <info-radio v-for="item in data" :current-value="currentValue" :name="name" :key="item.value" :id="item.id" :value="item.value" :price="item.price" :info="item.info">
            <p>{{ $t(item.value)}}</p>
            <p v-if="item.text">{{ $t(item.text)}}</p>
        </info-radio>
    </div>
</template>

<script>
    import InfoRadio from './InfoRadio'
    import { EventBus } from '../../services/eventBus'

    export default {
        created () {
            EventBus.$on('radio-button::new-value', function(value, name) {
                if (name == this.name) {
                    this.currentValue = value;
                }
            }.bind(this));
        },
        beforeDestroy() {
            EventBus.$off('radio-button::new-value')
        },
        name: "info-radios",
        props: {
            name: String,
            data: Array
        },
        components: {
            'info-radio': InfoRadio
        },
        data () {
            return {
                currentValue: '',
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/InfoRadios.vue